import { GEWERK } from './gemeinsam';
import { DataTable, EmptyState, type Spalte } from '../../muster';

/** Der Gewerkevorrang — wer wem ausweicht, pflegbar mit Begründung. */
export function Gewerkevorrang({ vorrang }: { vorrang: any[] }) {
  const spalten: Spalte<any>[] = [
    { schluessel: 'rang', titel: 'Rang', art: 'zahl', breite: '80px', wert: (v) => v.rang },
    {
      schluessel: 'gewerk', titel: 'Gewerk', immerSichtbar: true,
      wert: (v) => GEWERK[v.gewerk] ?? v.gewerk,
    },
    {
      schluessel: 'beweglichkeit', titel: 'Beweglichkeit',
      wert: (v) => v.beweglichkeit,
      inhalt: (v) => <span className="schwach">{v.beweglichkeit}</span>,
    },
    {
      schluessel: 'begruendung', titel: 'Begründung',
      wert: (v) => v.begruendung,
      inhalt: (v) => <span style={{ fontSize: 12 }}>{v.begruendung}</span>,
    },
  ];

  return (
    <DataTable
      name="Gewerkevorrang — wer weicht wem aus"
      spalten={spalten}
      zeilen={vorrang ?? []}
      schluessel={(v) => v.gewerk}
      sortierung={{ spalte: 'rang', richtung: 'auf' }}
      suche={false}
      ausfuhr
      leer={(
        <EmptyState
          titel="Kein Gewerkevorrang gepflegt."
          erklaerung={'Ohne Vorrang entscheidet keine Regel, wer ausweicht — die '
            + 'Einstufung fällt dann auf „gleicher Rang".'}
        />
      )}
    />
  );
}
